import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import type { useDatePickerConfig } from '../date-picker/use-date-picker-config';
import type { useDateRangePickerConfig } from '../date-range-picker/use-date-range-picker-config';
type DateRangePickerContextValue = ReturnType<typeof useDateRangePickerConfig>;
type DatePickerContextValue = ReturnType<typeof useDatePickerConfig>;
const DateRangePickerContext = createContext<DateRangePickerContextValue | null>(null);
const DatePickerContext = createContext<DatePickerContextValue | null>(null);
export const DateRangePickerProvider = t0 => {
  const $ = _c(3);
  const {
    children,
    config
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== config) {
    t1 = <DateRangePickerContext.Provider value={config}>{children}</DateRangePickerContext.Provider>;
    $[0] = children;
    $[1] = config;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const DatePickerProvider = t0 => {
  const $ = _c(3);
  const {
    children,
    config
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== config) {
    t1 = <DatePickerContext.Provider value={config}>{children}</DatePickerContext.Provider>;
    $[0] = children;
    $[1] = config;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useDateRangePicker = () => {
  const ctx = useContext(DateRangePickerContext);
  if (!ctx) {
    throw new Error("useDateRangePicker has to be used within <DateRangePickerProvider />");
  }
  return ctx;
};
export const useDatePicker = () => {
  const ctx = useContext(DatePickerContext);
  if (!ctx) {
    throw new Error("useDatePicker has to be used within <DatePickerProvider />");
  }
  return ctx;
};